import React, { memo } from "react";
import { Navigate } from "react-router-dom";
import { isAccessUser } from "./helper";

const HighOrder = ({ Compo, access, navigate }) => {
  return <>{isAccessUser(access) ? Compo : <Navigate to={navigate} />}</>;
};

export default memo(HighOrder);
